/* eslint-disable */
/* eslint-disable react/jsx-key */
/* eslint-disable no-irregular-whitespace */
import React, { useCallback, useMemo, useState } from "react";
import styles from "./ProgramDetailPage.module.css";
import { ProgramDetail } from "../../stores/program/model/Program";
import PuiTypography from "../../components/elements/PuiTypography";
import ViewCountIcon from "../../common/components/images/ViewCountIcon";
import GoodIcon from "../../common/components/images/GoodIcon";
import CommentIcon from "../../common/components/images/CommentIcon";
import { Divider } from "@material-ui/core";
import { format } from "date-fns";
import ProgramEpisodeList from "../index/components/program/ProgramEpisodeList";
import ChannelVideoCard from "../../common/components/ChannelList/ChannelVideoCard";
import { useNavigate } from "react-router-dom";
import useResponsive from "../../common/useResponsive";

export interface ProgramDetailPageProps {
  // チャンネル
  channel: ProgramDetail;
}



function ProgramDetailPageV2({channel}: {
  channel: ProgramDetail;
}) {
  const videos = useMemo(() => channel.videos, [channel.videos]);
  const [selectedVideoIdx,changeSelectedVideoIdx] = useState(() => {
          // 最新履歴の日付をとる（時間）
      const latestDate = Math.max(
        ...videos.map((item) => {
          if (item.viewingActivities.length > 0) {
            return Date.parse(item.viewingActivities[0].created);
          } else {
            return -1;
          }
        })
      );
      for (let j = 0; j < videos.length; j++) {
        // 視聴していないビデオをスキップ
        if (videos[j].viewingActivities.length === 0) {
          continue;
        }
        const date = Date.parse(videos[j].viewingActivities[0].created);
        const isFinished = videos[j].viewingActivities[0].isFinished;
        if (date === latestDate && !isFinished) {
          return j;
        } else if (date === latestDate && isFinished) {
          const index = j;
          if (index === videos.length - 1) return 0;
          return j+1;
        }
      }
      return videos.length -1;
  })
  const selectedVideo = useMemo(() => {
      return videos[selectedVideoIdx];
  }, [videos, selectedVideoIdx]); 

    const { isMobile } = useResponsive();
   const navigate = useNavigate();
  const goToVideo = useCallback(
    () => navigate(`/video/${selectedVideo.hash}`),
    [selectedVideo?.hash, navigate]
  );

    return (
    <div className={styles.container}>
      <div className={styles.videoArea}>
        <div className={styles.videoAreaLeft}>
          {selectedVideo && (
            <>
              <img
                src={selectedVideo.imageUrl}
                className={styles.selectedImg}
                alt={selectedVideo.title}
                onClick={goToVideo}
              />
              <div className={styles.titleRow}>
                <div className={styles.titleRowLeft}>
                  <PuiTypography size={isMobile ? 16 : 20} bold={true}>
                    {selectedVideo.title}
                  </PuiTypography>
                  <div className={styles.meta}>
                    <div className={styles.viewCount}>
                      <ViewCountIcon />
                    </div>
                    <PuiTypography size={14} bold={true} color={"gray-61"}>
                      {`${selectedVideo.viewCount}回視聴　・　${
                        selectedVideo.updated
                          ? format(
                              Date.parse(String(selectedVideo.updated).split("T")[0]),
                              "yyyy年MM月dd日"
                            )
                          : "不明"
                      }`}
                    </PuiTypography>
                  </div>
                </div>
                <div className={styles.titleRowRight}>
                  <div className={styles.goodInfo}>
                    <div className={styles.goodCountIcon}>
                      <GoodIcon />
                    </div>
                    <PuiTypography size={14} bold={true}>
                      {selectedVideo.reactionsCount}
                    </PuiTypography>
                  </div>
                  <div className={styles.commentInfo}>
                    <div className={styles.commentCountIcon}>
                      <CommentIcon />
                    </div>
                    <PuiTypography size={14} bold={true}>
                      {selectedVideo.commentsCount}
                    </PuiTypography>
                  </div>
                </div>
              </div>
              <Divider variant="middle" />
              <div className={styles.descriptionRow}>
                <PuiTypography size={14} bold={true}>
                  {selectedVideo.description}
                </PuiTypography>
              </div>
            </>
          )}
        </div>
        <div className={styles.videoAreaRight}>
          <div className={styles.episodeTitleRow}>
            <PuiTypography size={16} bold={true}>
              エピソード
            </PuiTypography>
            <PuiTypography
              size={14}
              bold={true}
              color={"gray-61"}
            >{`${selectedVideoIdx + 1}/${channel.videos.length}`}</PuiTypography>
          </div>
          <Divider variant="middle" />
          {channel.videos && selectedVideo && (
            <ProgramEpisodeList
              videoList={channel.videos}
              selected={selectedVideo}
              onCallback={(video) => {
               const idx = videos.findIndex(item => item.id === video.id)
                changeSelectedVideoIdx(idx)
              }}
            />
          )}
        </div>
      </div>
      {channel.relatedVideos.length > 0 && (
        <div className={styles.relatedVideoArea}>
          <div className={styles.relatedVideoTitle}>
            <PuiTypography size={20} bold={true}>
              関連動画
            </PuiTypography>
          </div>
          <div className={styles.relatedVideoList}>
            {channel.relatedVideos.map((video) => (
              <ChannelVideoCard video={video} key={video.id} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProgramDetailPageV2;
